import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=5369904a"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"
import style0 from "./Center.vue?vue&type=style&index=0&id=5369904a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports